import Tooltip from 'react-bootstrap/es/Tooltip';


export default Tooltip;